import React, { Component } from 'react'
import { TagInput } from '../../components'
import DFW_TAGS from './data/dfw-tags.json'

export default class TagInputHost extends Component {

    constructor(props) {
        super(props)
        this.state = { tags: ['advil', 'Coffee', 'banana', 'potato', 'Spaghetti', 'hamburger'], tags2: ['foo', 'bar', 'bat'] }
        window.componentUnderTest = this
    }

  onChange = (tags) => {
      this.setState({ tags })
  }

  onChange2 = (tags) => {
      this.setState({ tags2: tags })
  }

  render() {
      return (
          <div style={{ margin: '50px', width: '500px' }}>
              <TagInput
                  suggestions={DFW_TAGS}
                  tags={this.state.tags}
                  onChange={this.onChange}
              />
              <br />
              <div>Limited to 5 tags in this one:</div>
              <TagInput
                  suggestions={DFW_TAGS}
                  tags={this.state.tags2}
                  onChange={this.onChange2}
                  maxItems={5}
              />
          </div>)
  }
}
